import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported, type Analytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC-WmrdN97sYo180vXdBS3grtRnj_N8TzY",
  authDomain: "lancastersystemsautomation.firebaseapp.com",
  projectId: "lancastersystemsautomation",
  storageBucket: "lancastersystemsautomation.firebasestorage.app",
  messagingSenderId: "852645453784",
  appId: "1:852645453784:web:017d0eb208c5fc31879cad",
  measurementId: "G-2F2N7VPLE6"
};

const app = initializeApp(firebaseConfig);

export let analytics: Analytics | null = null;
if (typeof window !== "undefined") {
  isSupported().then((supported) => {
    if (supported) analytics = getAnalytics(app);
  });
}

export const db = getFirestore(app);
export const auth = getAuth(app);

export default app;
